import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import { FC, useEffect, useState } from 'react';
import { Box, DialogContent } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import {
	addGpsrRegulationsRequest,
	getRegulationsReferencesRequest,
} from 'redux/reducers/gpsr/reducer';
import {
	getGpsrRegulationsReferences,
	getGpsrRegulationsReferencesLoad,
} from 'redux/reducers/gpsr/selectors';
import { TGetRegulationsReferences } from 'redux/reducers/gpsr/types';
import { TAddRegulationsDialogProps } from './types';
import { RegulationsReferencesAutocomplete } from './RegulationsReferencesAutocomplete';

export const AddRegulationsDialog: FC<TAddRegulationsDialogProps> = ({
	open,
	setClose,
	emId,
	productTypeId,
	regulationsId = null,
	regulationsReferencesIdProps = null,
}) => {
	const dispatch = useDispatch();

	const regulationsReferences = useSelector(getGpsrRegulationsReferences);

	const [regulations, setRegulations] = useState<TGetRegulationsReferences[]>([]);

	useEffect(() => {
		const regulationsTmp = regulationsReferences?.data.map(item => ({
			...item,
			regulName: `${item.regulName} (${item.regulNumber}, ${item.regulYear})`,
		}));
		setRegulations(
			[...(regulationsTmp || [])].sort((a, b) => a.regulName.localeCompare(b.regulName)),
		);
	}, [dispatch, regulationsReferences]);

	const regulationsReferencesLoading = useSelector(getGpsrRegulationsReferencesLoad);

	const [regulationsIndex, setRegulationsIndex] = useState<number | null>(
		regulationsReferencesIdProps,
	);

	useEffect(() => {
		dispatch(getRegulationsReferencesRequest({}));
	}, [dispatch, productTypeId]);

	const reset = () => {
		setRegulationsIndex(null);
	};

	const handleSend = () => {
		if (regulationsIndex === null) return;
		dispatch(
			addGpsrRegulationsRequest({
				emId,
				productTypeId,
				body: {
					id: regulationsId,
					name: regulations[regulationsIndex]?.regulName ?? '',
					regulationId: regulations[regulationsIndex]?.id ?? null,
				},
			}),
		);
		reset();
		setClose();
	};

	return (
		<Dialog
			open={open}
			onClose={setClose}
			sx={{
				'& .MuiDialog-paper': {
					width: '600px',
					maxWidth: '600px',
					borderRadius: '12px',
				},
			}}
		>
			<DialogTitle color="primary">Add Regulations</DialogTitle>
			<DialogContent
				sx={{
					p: '0 12px 0px 12px',
				}}
			>
				<Box
					sx={{
						width: '100%',
						display: 'flex',
						flexDirection: 'column',
						gap: '4px',
						p: '12px 0',
					}}
				>
					{regulations.length > 0 && (
						<RegulationsReferencesAutocomplete
							valueIndex={regulationsIndex}
							setValueIndex={setRegulationsIndex}
							regulationsReferences={regulations}
						/>
					)}
				</Box>
			</DialogContent>
			<DialogActions>
				<Button
					onClick={() => {
						reset();
						setClose();
					}}
				>
					Cancel
				</Button>

				<Button onClick={handleSend} autoFocus disabled={regulationsIndex === null}>
					Send
				</Button>
			</DialogActions>
		</Dialog>
	);
};
